import { mergeStyles, useTheme } from "@fluentui/react";
import React, { useMemo } from "react";
import * as FAM from "model/FlexibleAttributeModel";

interface IProps {
    plan: FAM.IPlan
}

const PlanSummary: React.FunctionComponent<IProps> = ({ plan }) => {
    const theme = useTheme();

    const styleSummary = useMemo(() => {
        const styleSummary: Record<string, React.CSSProperties> = {
            "dl": {
                width: '100%',
                padding: '5px',
            },
            "dt": {
                fontWeight: 680,
                textAlign: 'right',
                width: "120px",
                padding: '5px',
            },
            "dd": {
                padding: '5px',
            }
        }
        return styleSummary;
    }, []);
    
    const tBodyClass = useMemo(() => {
        return mergeStyles({
            "td": {
            },
            "& > :nth-child(even)": {
                backgroundColor: theme.semanticColors.bodyDivider,
            }
        });
    }, [theme]);

    return (
        <table style={styleSummary.dl}>
            <tbody className={tBodyClass}>
                <tr>
                    <td style={styleSummary.dt}>Name</td>
                    <td style={styleSummary.dd}>{plan.name}</td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}>Funding Type</td>
                    <td style={styleSummary.dd}>{plan.fundingType?.name ?? '-'}</td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}>GF/NGF Type</td>
                    <td style={styleSummary.dd}>{plan.grandFathered?.name ?? '-'}</td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}>Deactivated</td>
                    <td style={styleSummary.dd}>{plan.deactivated ? 'Yes' : 'No'}</td>
                </tr>
            </tbody>
        </table>
    );
}

export default PlanSummary;